import React from 'react';
import { Route, Switch } from 'react-router';

import Serving from 'PointOfSale/modules/layouts/container/Serving';
import MealsTypes from 'PointOfSale/modules/mealTypes/container';
import ServingOptions from 'PointOfSale/modules/servingOptions/container';

import { POS_ROUTES } from 'PointOfSale/modules/common/constants';

const PageContent = () => {
  return (
    <Switch>
      {/* Setup */}
      <Route exact path={POS_ROUTES.HOME} component={MealsTypes} />
      <Route exact path={POS_ROUTES.SERVE_OPTIONS} component={ServingOptions} />

      {/* Serving */}
      <Route path={POS_ROUTES.SERVING} component={Serving} />
    </Switch>
  );
};

export default PageContent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/PageContent.js